// Generated by ReScript, PLEASE EDIT WITH CARE


var mumbai = "mumbai";

var delhi_NCR = "delhi ncr";

var delhi = "delhi";

var bangalore = "bangalore";

var hyderabad = "hyderabad";

var chennai = "chennai";

var ahmedabad = "ahmedabad";

var jaipur = "jaipur";

var pune = "pune";

var kolkata = "kolkata";

var surat = "surat";

var lucknow = "lucknow";

var coimbatore = "coimbatore";

var indore = "indore";

var nagpur = "nagpur";

var chandigarh = "chandigarh";

var vadodara = "vadodara";

var ludhiana = "ludhiana";

var kochi = "kochi";

var nashik = "nashik";

var visakhapatnam = "visakhapatnam";

var kanpur = "kanpur";

var trivandrum = "trivandrum";

var tiruppur = "tiruppur";

var kozhikode = "kozhikode";

var rajkot = "rajkot";

var bhopal = "bhopal";

var anand = "anand";

var agra = "agra";

var meerut = "meerut";

var thrissur = "thrissur";

var madurai = "madurai";

var gwalior = "gwalior";

var aurangabad = "aurangabad";

var mysore = "mysore";

var jabalpur = "jabalpur";

var nadiad = "nadiad";

var salem = "salem";

var vijayawada = "vijayawada";

var jalandhar = "jalandhar";

var bharuch = "bharuch";

var ambala = "ambala";

var raipur = "raipur";

var bhilai = "bhilai";

var mangalore = "mangalore";

var patna = "patna";

var prayagraj = "prayagraj";

var jodhpur = "jodhpur";

var ajmer = "ajmer";

var kota = "kota";

var varanasi = "varanasi";

var bhavnagar = "bhavnagar";

var jamnagar = "jamnagar";

var ujjain = "ujjain";

var ranchi = "ranchi";

var jalgaon = "jalgaon";

var goa = "goa";

var guwahati = "guwahati";

var panipat = "panipat";

var bhubaneswar = "bhubaneswar";

var ayodhya = "ayodhya";

var dubai = "dubai";

var sharjah = "sharjah";

var istanbul = "istanbul";

var dhaka = "dhaka";

export {
  mumbai ,
  delhi_NCR ,
  delhi ,
  bangalore ,
  hyderabad ,
  chennai ,
  ahmedabad ,
  jaipur ,
  pune ,
  kolkata ,
  surat ,
  lucknow ,
  coimbatore ,
  indore ,
  nagpur ,
  chandigarh ,
  vadodara ,
  ludhiana ,
  kochi ,
  nashik ,
  visakhapatnam ,
  kanpur ,
  trivandrum ,
  tiruppur ,
  kozhikode ,
  rajkot ,
  bhopal ,
  anand ,
  agra ,
  meerut ,
  thrissur ,
  madurai ,
  gwalior ,
  aurangabad ,
  mysore ,
  jabalpur ,
  nadiad ,
  salem ,
  vijayawada ,
  jalandhar ,
  bharuch ,
  ambala ,
  raipur ,
  bhilai ,
  mangalore ,
  patna ,
  prayagraj ,
  jodhpur ,
  ajmer ,
  kota ,
  varanasi ,
  bhavnagar ,
  jamnagar ,
  ujjain ,
  ranchi ,
  jalgaon ,
  goa ,
  guwahati ,
  panipat ,
  bhubaneswar ,
  ayodhya ,
  dubai ,
  sharjah ,
  istanbul ,
  dhaka ,
}
/* No side effect */
